// src/pages/Dashboard/components/CasePanel/CaseTitle.js

import React from 'react';

/**
 * Título do caso com ID
 * @param {object} caso - Caso selecionado
 */
const CaseTitle = ({ caso }) => {
  return (
    <div className="caso-titulo-dashboard">
      <h4>{caso.name}</h4>
      <span className="caso-id">ID: {caso.id}</span>
    </div>
  );
};

export default CaseTitle;